import React, { useMemo, useState } from "react";
import { TouchableOpacity, Text, View, StyleSheet } from "react-native";
import { format } from "date-fns";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import Tooltip from "./Tooltip";

type CardTagsProps = {
  item: any;
};

const CardTags: React.FC<CardTagsProps> = ({ item }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const date = useMemo(
    () => new Date(item.startDateTime ? item.startDateTime : item.releaseDate),
    [item.startDateTime ? item.startDateTime : item.releaseDate]
  );
  const formattedDate = item
    ? format(date, "do MMM, h:mmaaa")
    : "No date available";

  const tags = [
    {
      title: formattedDate,
      onTap: () => {},
    },
    {
      title: item.type === "Public" ? "Free" : "Paid",
      onTap: () => {},
    },
    {
      title: item.gameTitle,
      onTap: () => {},
    },
  ];

  return (
    <View style={styles.tagsContainer}>
      {tags.map((tag, index) => (
        <>
          <TouchableOpacity
            key={index}
            style={[
              styles.tagButton,
              {
                backgroundColor: AppColors.appViolentColor_6D08C3,
                width: index === 2 ? "100%" : "auto",
              },
            ]}
            onPress={() => {}}
            onMouseEnter={() => index === 2 && setTooltipVisible(true)}
            onMouseLeave={() => index === 2 && setTooltipVisible(false)}
            onPressIn={() => index === 2 && setTooltipVisible(true)}
            onPressOut={() => index === 2 && setTooltipVisible(false)}
          >
            <Text
              style={[AppFontStyle.REGULAR_ANYBODY_12, styles.textStyle]}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {tag.title}
            </Text>
          </TouchableOpacity>
          {index === 2 && (
            <Tooltip
              content={tag.title}
              // content={tag.title}
              visible={tooltipVisible}
            />
          )}
        </>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    columnGap: 8,
    rowGap: 8,
    marginVertical: 8,
  },
  tagButton: {
    paddingVertical: 3,
    paddingHorizontal: 10,
    backgroundColor: AppColors.appGreenColor_51AF07,
    shadowOpacity: 0,
    borderRadius: 7,
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    maxWidth: "100%",
  },
  textStyle: {
    color: "white",
  },
});

export default CardTags;
